import React from "react";
import classes from "../styles/Footer.module.css";
const socialLinks = [
  {
    id: 1,
    name: "Facebook",
    href: "https://www.facebook.com/za.if.03",
    pathData: [
      "M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z",
    ],
  },
  {
    id: 2,
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/rabbi-ginnat-noyon",
    pathData: [
      "M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z",
      "M2 12h6v18h-6v-18z",
      "M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z",
    ],
  },
  {
    id: 3,
    name: "WhatsApp",
    href: "https://api.whatsapp.com/send?phone=8801774247733",
    pathData: [
      "M27.281 4.65c-2.994-3-6.975-4.65-11.219-4.65-8.738 0-15.85 7.112-15.85 15.856 0 2.794 0.731 5.525 2.119 7.925l-2.25 8.219 8.406-2.206c2.319 1.262 4.925 1.931 7.575 1.931h0.006c0 0 0 0 0 0 8.738 0 15.856-7.113 15.856-15.856 0-4.238-1.65-8.219-4.644-11.219zM16.069 29.050v0c-2.369 0-4.688-0.637-6.713-1.837l-0.481-0.288-4.987 1.306 1.331-4.863-0.313-0.5c-1.325-2.094-2.019-4.519-2.019-7.012 0-7.269 5.912-13.181 13.188-13.181 3.519 0 6.831 1.375 9.319 3.862 2.488 2.494 3.856 5.8 3.856 9.325-0.006 7.275-5.919 13.188-13.181 13.188zM23.294 19.175c-0.394-0.2-2.344-1.156-2.706-1.288s-0.625-0.2-0.894 0.2c-0.262 0.394-1.025 1.288-1.256 1.556-0.231 0.262-0.462 0.3-0.856 0.1s-1.675-0.619-3.188-1.969c-1.175-1.050-1.975-2.35-2.206-2.744s-0.025-0.613 0.175-0.806c0.181-0.175 0.394-0.463 0.594-0.694s0.262-0.394 0.394-0.662c0.131-0.262 0.069-0.494-0.031-0.694s-0.894-2.15-1.219-2.944c-0.319-0.775-0.65-0.669-0.894-0.681-0.231-0.012-0.494-0.012-0.756-0.012s-0.694 0.1-1.056 0.494c-0.363 0.394-1.387 1.356-1.387 3.306s1.419 3.831 1.619 4.1c0.2 0.262 2.794 4.269 6.769 5.981 0.944 0.406 1.681 0.65 2.256 0.837 0.95 0.3 1.813 0.256 2.494 0.156 0.762-0.113 2.344-0.956 2.675-1.881s0.331-1.719 0.231-1.881c-0.094-0.175-0.356-0.275-0.756-0.475z",
    ],
  },
  {
    id: 4,
    name: "Cv",
    href: "https://drive.google.com/file/d/163QXvaXEvGXrACcrDvhjvjgszLiRDHD1/view?usp=sharing",
    pathData: [
      "M28.681 7.159c-0.694-0.947-1.662-2.053-2.724-3.116s-2.169-2.030-3.116-2.724c-1.612-1.182-2.393-1.319-2.841-1.319h-15.5c-1.378 0-2.5 1.121-2.5 2.5v27c0 1.378 1.122 2.5 2.5 2.5h23c1.378 0 2.5-1.122 2.5-2.5v-19.5c0-0.448-0.137-1.23-1.319-2.841zM24.543 5.457c0.959 0.959 1.712 1.825 2.268 2.543h-4.811v-4.811c0.718 0.556 1.584 1.309 2.543 2.268zM28 29.5c0 0.271-0.229 0.5-0.5 0.5h-23c-0.271 0-0.5-0.229-0.5-0.5v-27c0-0.271 0.229-0.5 0.5-0.5 0 0 15.499-0 15.5 0v7c0 0.552 0.448 1 1 1h7v19.5z",
      "M23 26h-14c-0.552 0-1-0.448-1-1s0.448-1 1-1h14c0.552 0 1 0.448 1 1s-0.448 1-1 1z",
      "M23 22h-14c-0.552 0-1-0.448-1-1s0.448-1 1-1h14c0.552 0 1 0.448 1 1s-0.448 1-1 1z",
      "M23 18h-14c-0.552 0-1-0.448-1-1s0.448-1 1-1h14c0.552 0 1 0.448 1 1s-0.448 1-1 1z",
    ],
  },
];

const Footer = () => {
  return (
    <section className={classes.footer}>
      <div className={`${classes.footer__wrapper} ${"container"}`}>
        <div className={classes.footer__left}>
          <a
            href="mailto:rabbiginnatnoyon@gmail.com"
            target="_blank"
            rel="noreferrer"
            className={classes.email}
          >
            rabbiginnatnoyon@gmail.com
          </a>
          {/* <div className={classes.phone}>+880 1701039997</div> */}
        </div>
        <div className={classes.footer__right}>
          {socialLinks.map(({ href, pathData, id }) => {
            return (
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                key={id}
                className={classes.social__button}
              >
                <svg
                  className={classes.social__link}
                  fill="var(--color-text)"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                >
                  {pathData.map((pd, i) => (
                    <path
                      key={i}
                      fillRule="evenodd"
                      d={pd}
                      clipRule="evenodd"
                    />
                  ))}
                </svg>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Footer;
